import { render, staticRenderFns } from "./chipmanage.vue?vue&type=template&id=090ac9bb&scoped=true&"
import script from "./chipmanage.vue?vue&type=script&lang=js&"
export * from "./chipmanage.vue?vue&type=script&lang=js&"
import style0 from "./chipmanage.vue?vue&type=style&index=0&id=090ac9bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090ac9bb",
  null
  
)

export default component.exports